var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.all},[(_vm.topshow)?_c('div',{class:_vm.styletop},[_vm._v("\n\t\t\t"+_vm._s(_vm.titletop)+"\n\t\t")]):_vm._e(),_c('div',{class:_vm.stylebot},[_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")])])])}
var staticRenderFns = []

export { render, staticRenderFns }